declare global {
  interface Window {
    PageDataLayer: any[];
  }
}
let pageDataLayerQueue: any[] = [];
let timer: NodeJS.Timeout | null = null;
const sendAnalytics = (eventName: string, eventObj = {}) => {
  const event = `MUNSHIFY_${eventName}`;
  if (window.PageDataLayer) {
    window.PageDataLayer.push({ event, ...eventObj });
  } else {
    pageDataLayerQueue.push({ event, ...eventObj });
  }
  if (pageDataLayerQueue.length && !timer) {
    timer = setInterval(() => {
      if (window.PageDataLayer) {
        for (const queueData of pageDataLayerQueue) {
          window.PageDataLayer.push(queueData);
        }
        pageDataLayerQueue = [];
        clearInterval(timer);
        timer = null;
      }
    }, 1000);
  }
};

export default sendAnalytics;
